import {gql} from '@apollo/client';

export const UPDATE_GLOBAL_WALLET_PLATFORM_SETTINGS = gql`
  mutation UpdateGlobalWalletPlatformSettings(
    $input: WalletPlatformSettingsInput!
  ) {
    updateGlobalWalletPlatformSettings(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on GlobalPlatformWalletSettings {
        isDepositAllowed
        isTransfersAllowed
        isWithdrawalAllowed
      }
    }
  }
`;

export const UPDATE_PAYMENT_PROVIDER_SETTINGS = gql`
  mutation UpdatePaymentProviderCurrencySettings(
    $input: [UpdatePaymentProviderCurrencySettingsInput]!
  ) {
    updatePaymentProviderCurrencySettings(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on PaymentProviderSettings {
        enabled
      }
    }
  }
`;

export const UPDATE_MOBILE_MONEY_SETTINGS = gql`
  mutation UpdatePaymentProviderSettings(
    $input: UpdatePaymentProviderInputSettings!
  ) {
    updatePaymentProviderSettings(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on PaymentProviderSettings {
        enabled
        provider
      }
    }
  }
`;

export const UPDATE_WALLET_CURRENCY_SETTINGS = gql`
  mutation UpdatePlatformWalletCurrencySettings(
    $input: WalletOperationSettingsInput!
  ) {
    updatePlatformWalletCurrencySettings(input: $input) {
      ... on WalletCurrencySettings {
        currency
        currencyName
      }
      ... on Error {
        message
        statusCode
      }
    }
  }
`;

export const UPDATE_USER_WALLET_TRANSACTION = gql`
  mutation UpdateUserWalletTransaction($input: UpdateUserTransactionInput!) {
    updateUserWalletTransaction(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on WalletTransaction {
        id
        referenceId
        failureReasonCode
        failureReasonMessages
      }
    }
  }
`;

export const UPDATE_WALLET_TRANSACTION_TRANSFER_ID = gql`
  mutation UpdateWalletTransactionTransferId(
    $input: UpdateWalletTransactionTransferIdInput!
  ) {
    updateWalletTransactionTransferId(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on WalletTransaction {
        id
        referenceId
        status
      }
    }
  }
`;

export const UPDATE_USER_WALLET_SETTINGS = gql`
  mutation UpdateUserWalletSettings($input: UpdateUserWalletSettingsInput!) {
    updateUserWalletSettings(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on Wallet {
        id
      }
    }
  }
`;

export const CREATE_FX_EXCHANGE_RATE = gql`
  mutation CreateFxExchangeRate($input: ExchangeRateInput!) {
    createFxExchangeRate(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ExchangeRate {
        sourceCurrency
      }
    }
  }
`;

export const UPDATE_FX_EXCHANGE_RATE = gql`
  mutation UpdateFxExchangeRate($input: ExchangeRateInput!) {
    updateFxExchangeRate(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ExchangeRate {
        id
      }
    }
  }
`;

export const DELETE_FX_EXCHANGE_PAIR = gql`
  mutation RemoveFxExchangeRate($removeFxExchangeRateId: ID!) {
    removeFxExchangeRate(id: $removeFxExchangeRateId) {
      ... on Error {
        message
        statusCode
      }
      ... on ExchangeRate {
        id
      }
    }
  }
`;

export const ENABLE_PAIR_STATUS = gql`
  mutation EnableOrDisableFxExchangeRate(
    $enableOrDisableFxExchangeRateId: ID!
    $isEnabled: Boolean!
  ) {
    enableOrDisableFxExchangeRate(
      id: $enableOrDisableFxExchangeRateId
      isEnabled: $isEnabled
    ) {
      ... on Error {
        message
        statusCode
      }
      ... on ExchangeRate {
        id
      }
    }
  }
`;

export const ENABLE_OR_DISABLE_SOURCE_CURRENCY = gql`
  mutation EnableOrDisableSourceCurrencyForSwap(
    $currency: WalletCurrency!
    $isEnabled: Boolean!
  ) {
    enableOrDisableSourceCurrencyForSwap(
      currency: $currency
      isEnabled: $isEnabled
    ) {
      ... on Error {
        message
        statusCode
      }
      ... on WalletCurrencySettings {
        swap {
          sourceCurrencyEnabledForSwap
        }
      }
    }
  }
`;

export const FULFIL_OR_REJECT_SWAP_TRANSACTION = gql`
  mutation FulfilOrRejectPendingSwapTransaction(
    $swapTransactionId: ID!
    $status: UpdateWalletTransactionStatus!
    $reasonForFailure: String
  ) {
    fulfilOrRejectPendingSwapTransaction(
      swapTransactionId: $swapTransactionId
      status: $status
      reasonForFailure: $reasonForFailure
    ) {
      ... on Error {
        message
        statusCode
      }
      ... on SwapTransactions {
        id
      }
    }
  }
`;

export const UPDATE_SWAP_TRANSACTION_RATE = gql`
  mutation UpdateSwapTransaction($input: UpdateSwapTransactionInput) {
    updateSwapTransaction(input: $input) {
      ... on Error {
        message
        statusCode
      }
    }
  }
`;

export const CREATE_USER_SWAP_TRANSACTION = gql`
  mutation AdminSwapCurrencies($input: AdminCurrencySwapInput!) {
    adminSwapCurrencies(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on SwapTransactions {
        id
        isUserDabaPro
        rate
        rateUsed
        configuredPairRate
        adminEnteredRate
        customExchangeRateInTargetCurrency
        amountPaid
        amountSwapped
        amountReceived
        calculatedFees
        actualFeeWithoutDiscount
        feesWithDiscountApplied
        usedCustomExchangeRate
        metadata
        appliedFeeSchedule {
          feeType
          fixedFeeAmount
          variableFeeAmount
        }
        sourceCurrency {
          currency
          currencySymbol
          currencyName
        }
        discount {
          feeType
          fixedFeeAmount
          variableFeeAmount
        }
        feeSchedule {
          feeType
          fixedFeeAmount
          variableFeeAmount
        }
        currentMarketRate
        status
      }
    }
  }
`;

export const SET_DAILY_THRESHOLD_FOR_SWAP = gql`
  mutation SetDailyThresholdForAutomaticSwap(
    $sourceCurrency: WalletCurrency!
    $targetCurrency: WalletCurrency!
    $amount: Float!
    $shouldNotifyAdminIfRemainingIsBelow: Float
  ) {
    setDailyThresholdForAutomaticSwap(
      sourceCurrency: $sourceCurrency
      targetCurrency: $targetCurrency
      amount: $amount
      shouldNotifyAdminIfRemainingIsBelow: $shouldNotifyAdminIfRemainingIsBelow
    ) {
      ... on Error {
        message
        statusCode
      }
      ... on ExchangeRate {
        id
      }
    }
  }
`;

export const CREATE_DEPOSIT_TX = gql`
  mutation CreateManualDepositWalletTransaction(
    $input: CreateManualWalletTransactionInput!
  ) {
    createManualDepositWalletTransaction(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithManualCreateWalletTransaction {
        data {
          amount
        }
      }
    }
  }
`;

export const CREATE_WITHDRAWAL_TX = gql`
  mutation CreateManualWithdrawalWalletTransaction(
    $input: CreateManualWalletTransactionInput!
  ) {
    createManualWithdrawalWalletTransaction(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithManualCreateWalletTransaction {
        data {
          status
        }
      }
    }
  }
`;

export const TRIGGER_WALLET_REPORT = gql`
  mutation TriggerWalletReportJob($emails: [String!]!) {
    triggerWalletReportJob(emails: $emails) {
      ... on Error {
        message
        statusCode
      }
      ... on Response {
        message
      }
    }
  }
`;

export const PRE_SIGN_MEDIA_URL = gql`
  mutation PresignMediaURL($input: PresignMediaURLInput!) {
    presignMediaURL(input: $input) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithAnything {
        data
        message
      }
    }
  }
`;

export const AUTOMATE_WITHDRAWAL = gql`
  mutation AutomateWithdrawal($input: AutomateWithdrawalInput!) {
    automateWithdrawal(input: $input) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithAnything {
        message
        data
      }
    }
  }
`;

export const BULK_UPDATE_PENDING_TRANSACTIONS = gql`
  mutation BulkUpdatePendingTransactions(
    $input: BulkUpdatePendingTransactionsInput
  ) {
    bulkUpdatePendingTransactions(input: $input) {
      ... on Error {
        statusCode
        message
      }
      ... on Response {
        message
      }
    }
  }
`;

export const UPDATE_WALLET_TRANSACTION_FILES = gql`
  mutation ModifyFilesForTransaction($input: ModifyFilesForTransactionInput!) {
    modifyFilesForTransaction(input: $input) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithAnything {
        message
      }
    }
  }
`;

// A CSV of every swap matching the filters (never just one page), behind a
// signed URL that expires after two hours.
export const EXPORT_SWAP_TRANSACTIONS = gql`
  mutation ExportSwapTransactions($input: SwapFilters) {
    exportSwapTransactions(input: $input) {
      __typename
      ... on SwapExportFile {
        url
        fileName
        count
      }
      ... on Error {
        message
        statusCode
      }
    }
  }
`;

// A bulk job's receipt and progress, shared with the job queries.
export const BULK_SWAP_JOB_FIELDS = `
  jobId
  status
  totalMatched
  attempted
  succeeded
  failedCount
  skipped
  failed {
    id
    message
  }
  requestedById
  requestedBy {
    id
    firstName
    lastName
    email
  }
  createdAt
  startedAt
  completedAt
`;

// Sent once per confirmed action. Returns a durable job straight away (usually
// QUEUED); the backend works through the swaps on its own.
export const BULK_FULFIL_OR_REJECT_SWAPS = gql`
  mutation StartBulkSwapJob($input: BulkSwapTransactionInput!) {
    bulkFulfilOrRejectPendingSwapTransactions(input: $input) {
      __typename
      ... on BulkSwapTransactionJob {
        ${BULK_SWAP_JOB_FIELDS}
      }
      ... on Error {
        message
        statusCode
      }
    }
  }
`;

// Inline, not a job: one rate is written to every pending swap in the
// selection and the full outcome comes back in the same response.
export const BULK_UPDATE_SWAP_RATE = gql`
  mutation BulkUpdateSwapTransactionRate($input: BulkSwapRateUpdateInput!) {
    bulkUpdateSwapTransactionRate(input: $input) {
      __typename
      ... on BulkSwapRateUpdateResult {
        rate
        totalMatched
        updated
        failedCount
        failed {
          id
          message
        }
      }
      ... on Error {
        message
        statusCode
      }
    }
  }
`;
